import { Subject } from 'rxjs';

class Options {
    public interval?:number
    public class?:any
    public key?:string
}

export class SuperObserveList {

    private key:string = "id";
    public items:Array<any> = [];
    public items_by_key = {};
    private items$ = new Subject();
    public onChange = new Subject();
    public hasChanged = new Subject();

    constructor(options?:Options) {

        if( options?.key?.length > 0 ) {
            this.key = options.key
        }

        this.items$.subscribe( (x:any) => {
            if( x.flag && x.flag === "deleted") {
                console.log("delete", x)
                delete this.items_by_key[x[this.key]]
            }
            else {
                if( options?.class ) {
                    // const className = options.class
                    this.items_by_key[x[this.key]] = new options.class(x);
                }
                else {
                    this.items_by_key[x[this.key]] = x
                }
            }
            this.items = []
            Object.keys(this.items_by_key).map( key => {
                this.items.push(this.items_by_key[key])
            })
            this.onChange.next({}) 
        })
    }

    public get(id) {
        return this.items_by_key[id]
    }
    
    private setId(key:string) {
        this.key = key
        return this 
    }

    public reset() {
        this.items = []
        this.items_by_key = {}
    }

    public change() {
        this.hasChanged.next(true)
    }

    /// Add an object to list. 
    public push(x:any) {
        if(Array.isArray(x)) {
            x.map( _x => {
                this.items$.next(_x)
            })
            this.hasChanged.next(true)
        }
        else {
            this.items$.next(x)
            this.hasChanged.next(true)
        }
    }

    public remove(x:any) {
        if(Array.isArray(x)) {
            x.map( _x => {
                _x.flag = "deleted"
                this.items$.next(_x)
            })
            this.hasChanged.next(true)
        }
        else {
            x.flag = "deleted"
            this.items$.next(x)
            this.hasChanged.next(true)
        }
    }

}
